module.exports = __webpack_public_path__ + "static/media/endless-nights.8f96964d.mp3";